export default {
  title: '產品列表',
  addProduct: '新增產品',
  editProduct: '編輯產品',
  productName: '產品名稱',
  productNo: '產品編號',
  productCategory: '產品分類',
  productLang: '語言版本',
  id: 'ID',
  productInfo: '產品資訊',
  retailPrice: '產品零售價',
  spec: '產品規格',
  singleSpec: '單規格',
  multiSpec: '多規格',
  detail: '詳情',
  multiSpecModal: '多規格資訊',
  specNo: '規格編號',
  specInfo: '規格資訊',
  price: '價格',
  select: '選擇',
  selected: '已選擇',
  selectedProducts: '已選產品',
  unselectedProducts: '未選產品',
};
